import {Controller} from "stimulus"
import $ from 'jquery';
import bootbox from 'bootbox/bootbox';
import toastr from 'toastr/toastr'
import {obtenerIdCheckDatatable} from './admin_controller'
import 'toastr/toastr.scss'
import 'bootstrap-table/dist/bootstrap-table.min.css'
import 'bootstrap-table/dist/bootstrap-table.min'
import 'bootstrap-table/dist/locale/bootstrap-table-es-ES.min'
import 'bootstrap-table/dist/extensions/custom-view/bootstrap-table-custom-view'
import 'bootstrap-table/dist/extensions/filter-control/bootstrap-table-filter-control.min.css'
import 'bootstrap-table/dist/extensions/filter-control/bootstrap-table-filter-control'


export default class extends Controller {

    connect() {

        toastr.options = {
            "closeButton": false,
            "debug": false,
            "newestOnTop": false,
            "progressBar": true,
            "positionClass": "toast-bottom-right",
            "preventDuplicates": false,
            "onclick": null,
            "showDuration": "300",
            "hideDuration": "1000",
            "timeOut": "3000",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
        }

        let table = $('#table');
        let admin_table = $('#admin_table');
        let commercial_table = $('#commercial_table');
        let revision_table = $('#revision_table');
        let revision_history_table = $('#revision_history_table');

        table.bootstrapTable({
            language: 'es',
            pagination: true,
            search: true,
            refresh: true,
            sidePagination: "server",
            showRefresh: "true",
            pageSize: 10,
            pageList: "[10, 25, 50, 100, 200, All]",
            toolbar: '#toolbar',
            toolbarAlign: "left",
            idField: "id",
            selectItemName: "id",
            onLoadSuccess: function (data) {
                table.bootstrapTable('checkInvert');
            }

        });
        admin_table.bootstrapTable({
            language: 'es',
            pagination: true,
            search: false,
            refresh: true,
            sidePagination: "server",
            showRefresh: "true",
            pageSize: 5,
            pageList: "[5, 25, 50, 100, 200, All]",
            toolbar: '#toolbar',
            toolbarAlign: "left",
            idField: "id",
            selectItemName: "id",
            onLoadSuccess: function (data) {
                table.bootstrapTable('checkInvert');
            }

        });
        commercial_table.bootstrapTable({
            language: 'es',
            pagination: true,
            search: true,
            refresh: true,
            showRefresh: "true",
            pageSize: 8,
            pageList: "[8, 25, 50, 100, 200, All]",
            toolbar: '#toolbar',
            toolbarAlign: "left",
            idField: "id",
            selectItemName: "id",
            extensions: ['customView'],
            showCustomView: true,
            customView: buildCustomView.bind(this),
            customViewDefaultView: true,
            queryParams: function(params) {
                return {
                    limit: params.limit,
                    offset: params.offset,
                    search: params.search
                };
            },
            columns: [
                { field: 'username', title: 'Usuario' },
                { field: 'email', title: 'Email' },
                { field: 'messages', title: 'Mensajes' },
                { field: 'notification', title: 'Notificaciones' },
                { field: 'action', title: 'Acción'}
            ],
            onLoadSuccess: function (data) {
                table.bootstrapTable('checkInvert');
            }

        });
        revision_table.bootstrapTable({
            language: 'es',
            pagination: true,
            search: true,
            refresh: true,
            sidePagination: "server",
            showRefresh: "true",
            pageSize: 5,
            pageList: "[5, 25, 50, 100, 200, All]",
            toolbar: '#toolbar',
            toolbarAlign: "left",
            idField: "id",
            selectItemName: "id",
            onLoadSuccess: function (data) {
                table.bootstrapTable('checkInvert');
            }

        });
        revision_history_table.bootstrapTable({
            language: 'es',
            pagination: true,
            search: true,
            refresh: true,
            sidePagination: "server",
            showRefresh: "true",
            pageSize: 5,
            pageList: "[5, 25, 50, 100, 200, All]",
            toolbar: '#toolbar',
            toolbarAlign: "left",
            idField: "id",
            selectItemName: "id",
            onLoadSuccess: function (data) {
                table.bootstrapTable('checkInvert');
            }

        });

        $('table_client').bootstrapTable();

        $('#checkBtn').on('change', function () {
            $('.inputBtnDataTable').prop('checked', $(this).is(':checked'));
        })

        function buildCustomView(data) {
            const template = $('#commercial-table').html()
            let view = ''

            $.each(data, function (i, row) {
                view += `
                        <div class="col-lg-3 col-md-6 col-12">
                            <div class="card  border-light mb-3">
                                <div class="card-header">${row.username}</div>
                                <div class="card-body text-secondary">
                                    <h4 class="card-title">
                                        Mensajes sin leer:  ${row.notification}
                                    </h4>
                                    <hr>
                        <div class="card-text">
                            Total de mensajes: ${row.messages}
                        </div>
                    </div>
                        <div class="card-footer bg-transparent border-light">
                            <a class='btn btn-primary' href='/commercial/rooms/${row.room}/show/${row.user_id}'><span class='icon-eye'></span> Ver mensajes</a>
                        </div>
                    </div>
                </div>`
            })

            return `<div class="row">${view}</div>`
        }

    }


    delete(e) {
        bootbox.confirm({
            message: "¿Seguro que desea eliminar este elemento?",
            buttons: {
                confirm: {
                    label: '<i class="fa fa-check"></i> Aceptar',
                    className: 'btn-success'
                },
                cancel: {
                    label: '<i class="fa fa-times"></i> Cancelar',
                    className: 'btn-secondary'
                }
            },
            size: 'small',
            callback: function (result) {
                if (result) {
                    $.ajax({
                        url: e.target.dataset.target + '/delete',
                        data: {
                            format: 'json'
                        },
                        type: 'GET',
                        success: function (data) {
                            if (data.success) {
                                toastr.success(data.msg);
                                $('#table').bootstrapTable('refresh');
                            } else {
                                toastr.error(data.msg);
                                // console.log(data.msg);
                            }
                        }
                    })
                }
            }
        })

    }

    really_delte(e) {
        bootbox.confirm({
            message: "¿Seguro que desea eliminar este elemento?",
            buttons: {
                confirm: {
                    label: '<i class="fa fa-check"></i> Aceptar',
                    className: 'btn-success'
                },
                cancel: {
                    label: '<i class="fa fa-times"></i> Cancelar',
                    className: 'btn-secondary'
                }
            },
            size: 'small',
            callback: function (result) {
                if (result) {
                    $.ajax({
                        url: e.target.dataset.target + '/really_delte',
                        data: {
                            format: 'json'
                        },
                        type: 'GET',
                        success: function (data) {
                            if (data.success) {
                                toastr.success(data.msg);
                                $('#table').bootstrapTable('refresh');
                            } else {
                                toastr.error(data.msg);
                            }
                        }
                    })
                }
            }
        })

    }

    really_delete_block(e) {
        const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
        let ids = obtenerIdCheckDatatable()
        if(ids.length === 0){
            toastr.info('Debe seleccionar la menos un elemento para continuar','Información')
        }else{
            bootbox.confirm({
                message: `¿Seguro que desea eliminar estos ${ids.length} elementos?`,
                buttons: {
                    confirm: {
                        label: '<i class="fa fa-check"></i> Aceptar',
                        className: 'btn-success'
                    },
                    cancel: {
                        label: '<i class="fa fa-times"></i> Cancelar',
                        className: 'btn-secondary'
                    }
                },
                size: 'small',
                callback: function (result) {
                    if (result) {
                        $.ajax({
                            url: location.origin + `/${sessionStorage.getItem('locale')}/admin/users/really_delete_block`,
                            headers: {'X-CSRF-Token': csrfToken},
                            data: {
                                format: 'json',
                                ids: ids
                            },
                            type: 'GET',
                            success: function (data) {
                                if (data.success) {
                                    toastr.success(data.msg);
                                    $('#table').bootstrapTable('refresh');
                                } else {
                                    toastr.error(data.msg);
                                }
                            }
                        })
                    }
                }
            })
        }


    }

    block(e) {
        bootbox.confirm({
            message: "¿Seguro que desea bloquear el acceso y la renta a este usuario?",
            buttons: {
                confirm: {
                    label: '<i class="fa fa-check"></i> Aceptar',
                    className: 'btn-success'
                },
                cancel: {
                    label: '<i class="fa fa-times"></i> Cancelar',
                    className: 'btn-secondary'
                }
            },
            size: 'small',
            callback: function (result) {
                if (result) {
                    $.ajax({
                        url: e.target.dataset.target + '/block',
                        data: {
                            format: 'json'
                        },
                        type: 'GET',
                        success: function (data) {
                            if (data.success) {
                                toastr.success(data.msg);
                                $('#table').bootstrapTable('refresh');
                            } else {
                                toastr.error(data.msg);
                                // console.log(data.msg);
                            }
                        }
                    })
                }
            }
        })

    }

    change_status(e) {

        bootbox.confirm({
            message: "¿Seguro que desea cambiar el estado de disponibilidad?",
            buttons: {
                confirm: {
                    label: '<i class="fa fa-check"></i> Aceptar',
                    className: 'btn-success'
                },
                cancel: {
                    label: '<i class="fa fa-times"></i> Cancelar',
                    className: 'btn-secondary'
                }
            },
            size: 'small',
            callback: function (result) {
                if (result) {
                    $.ajax({
                        url: e.target.dataset.target,
                        data: {
                            format: 'json'
                        },
                        type: 'GET',
                        success: function (data) {
                            if (data.success) {
                                toastr.success(data.msg);
                                $('#table').bootstrapTable('refresh');
                            } else {
                                toastr.error(data.msg);
                                // console.log(data.msg);
                            }
                        }
                    })
                }
            }
        })

    }

    commercial(e) {
        // console.log(e);
        bootbox.confirm({
            message: "¿Seguro que desea poner este usuario como Comercial del sitio?",
            buttons: {
                confirm: {
                    label: '<i class="fa fa-check"></i> Aceptar',
                    className: 'btn-success'
                },
                cancel: {
                    label: '<i class="fa fa-times"></i> Cancelar',
                    className: 'btn-secondary'
                }
            },
            size: 'small',
            callback: function (result) {
                if (result) {
                    $.ajax({
                        url: e.target.dataset.target,
                        data: {
                            format: 'json'
                        },
                        type: 'POST',
                        success: function (data) {
                            if (data.success) {
                                toastr.success(data.msg);
                                $('#table').bootstrapTable('refresh');
                            } else {
                                toastr.error(data.msg);
                                // console.log(data.msg);
                            }
                        }
                    })
                }
            }
        })

    }
}